import React from "react";
import { baseUrl, GET_NETWORK_ICON } from "../../../../../utils";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";
export default function IconSection({ iconsList, value }) {
  const isAddBtn = iconsList.length > 5;
  return (
    <>
      {value}
      <ul className="platform__icons colored_social_icons">  
        {iconsList.slice(0, 5).map((icon) => (
          <li key={icon.id}>
            {
              icon.id == 1 ? <FontAwesomeIcon type={'brands'} icon={'x-twitter'} iconClass={''} />
             : <img alt={icon.name} src={baseUrl(`icons/social-icons/${GET_NETWORK_ICON(icon.id)}.svg`)} height="16" width="16" />
            }
          </li>
        ))}
        {isAddBtn && (
          <li>
              <FontAwesomeIcon type={'light'} icon={'circle-plus'} iconClass={'text-gradient'} />
              <ul className="platform__more_">
                {iconsList.slice(5,iconsList.length).map((icon) => (
                <li key={icon.id}>
                  <img alt={icon.name} src={baseUrl(`icons/social-icons/${GET_NETWORK_ICON(icon.id)}.svg`)} height="16" width="16" />
                </li>
                ))}
              </ul>
            </li>
        )}
      </ul>
    </>
  );
}


export function IconSectionToolTip({networkList}){
  return <div className="tooltip__content">
  <ul className="platform__icons colored_social_icons">
      <li>
          {networkList.map(({ name, icon, id }) => (
              <i title={name} className={`fa ${icon}`} key={id}></i>
          ))}
      </li>
  </ul>
</div>
}
